module.exports = __webpack_public_path__ + "img/activity_2_splash.714d3727.jpg";